import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

/**
 * /delivery - send each person to their permission level in the Delivery
 * Portal: a manager to the dashboard, anyone else who can drive to their route.
 * With no network, go to the driver view, which opens from its saved route.
 */
const DeliveryHome: React.FC = () => {
  const { loading, user, authFailure, canManageDelivery, canAccessDeliveryPortal } = useAuth();

  if (loading) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        <div>Loading…</div>
      </div>
    );
  }
  if (!user) {
    return <Navigate to={authFailure === 'network' ? '/delivery/driver' : '/login?next=/delivery'} replace />;
  }
  if (canManageDelivery) return <Navigate to="/delivery/dashboard" replace />;
  if (canAccessDeliveryPortal) return <Navigate to="/delivery/driver" replace />;
  return <Navigate to="/dashboard" replace />;
};

export default DeliveryHome;
